<div>
  <h3 class="h3">{{ 'systemSettings.systemSettings' | transloco }}</h3>

  <!-- Skeleton Loader -->
  @if (!systemSettingsDataLoaded) {
    <div class="skeleton-loader">
      <div class="card shadow mt-2 w-50">
        <div class="card-body p-4">
          <div class="d-flex justify-content-between py-2">
            <div class="skeleton" style="width: 200px; height: 24px;"></div>
            <div class="skeleton" style="width: 200px; height: 36px; border-radius: 6px;"></div>
          </div>
          <div class="skeleton" style="width: 100%; height: 1px; margin: 12px 0;"></div>
          <div class="skeleton" style="width: 300px; height: 18px; margin-bottom: 8px;"></div>
          <div class="skeleton" style="width: 90%; height: 14px; margin-bottom: 6px;"></div>
          <div class="skeleton" style="width: 80%; height: 14px;"></div>
        </div>
      </div>
    </div>
  }

  @if (systemSettingsDataLoaded && systemSettings) {
    <div class="card shadow mt-2 w-50">
      <div class="card-body p-4">
        <!-- d-flex flex-row justify-content-between -->
        <div class="row">
          <!-- d-flex flex-column -->
          @if (systemSettings) {
            <div class="d-flex justify-content-between py-2">
              <div class="d-flex flex-column">
                <h4 class="h4">{{ 'systemSettings.freeTrialDuration' | transloco }}</h4>
              </div>
              <button pButton type="button" class="p-button-primary p-button-sm p-button-outlined"
                (click)="onShowSystemSettingDailog(systemSettings)" icon="fa fa-pencil" [label]="'systemSettings.editFreeTrialDuration' | transloco">
              </button>
            </div>
            <hr />
            <div class="d-flex flex-column mt-2">
              <span class="mb-2">
                <div class="d-flex flex-column">
                  <span class="fw-semibold text-uppercase">{{ 'systemSettings.freeTrialInDays' | transloco: { days: systemSettings.FreeTrialPeriodDays } }}</span>
                  <p class="text-muted"><i class="fa fa-info-circle me-1"></i>{{ 'systemSettings.globalSettingInfo' | transloco }}</p>
              </div>
            </span>
          </div>
        }
      </div>
    </div>
  </div>
}
</div>

<p-dialog [header]="'systemSettings.freeTrialSettings' | transloco" [(visible)]="systemSettingsDailogVisible" [modal]="true"
  [style]="{ 'width': '450px' }" (onHide)="closeDialog()">
  <div class="p-fluid p-2">
    @if (systemSettingFormData) {
      <form class="form-horizontal">
        <div class="form-body">
          <div class="row">
            <div class="form-group mb-2">
              <label for="freeTrialPeriodDays" class="form-label">{{ 'systemSettings.freeTrialDurationInDays' | transloco }}</label>
              <input type="number" class="form-control"
                [placeholder]="'systemSettings.trialDaysPlaceholder' | transloco"
                [(ngModel)]="systemSettingFormData.freeTrialPeriodDays" name="freeTrialPeriodDays" min="0"
                id="freeTrialPeriodDays" (input)="preventNegativeValues($event)" required />
                <div class="text-secondary mt-1">{{ 'systemSettings.trialDaysHint' | transloco }}</div>
              </div>
            </div>
            <div class="d-grid mt-2">
              <button pButton type="button" (click)="onSaveSystemSettings()" [label]="'systemSettings.saveChanges' | transloco"
              [disabled]="!systemSettingFormData.freeTrialPeriodDays" class="p-button-primary p-button-outlined"></button>
            </div>
          </div>
        </form>
      }
    </div>
  </p-dialog>